import React from 'react';
import i18n from '../../../../utils/ChrI18n';
import ChrLink from '../../../generic/Utils/ChrLink';
import useCustomizeCookiePreferencesModal from './custom/useCustomizeCookiePreferencesModal';
import { handleManageCookiesButtonClick } from '../utils';

const ManageCookiesLink = ({ data }) => {

  const { modalControls, modalContent } = useCustomizeCookiePreferencesModal(data)

  return (
    <>
      <ChrLink onClick={() => handleManageCookiesButtonClick(modalControls.showModal)}>{i18n.t("footer.manage_cookies")}</ChrLink>
      {modalContent}
    </>
  );
}

export default ManageCookiesLink;